import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpBackend, HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { HttpService, SsrCacheBackend } from './core/http';
import { apiAcceptLanguageInterceptor, apiErrorInterceptor, apiPrefixInterceptor } from './core/http/interceptors';
import { appRoutes } from './app-routing';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { provideLanguageInitializer, TranslateLoaderOverrid } from './i18n';
import { environment } from '@env/environment';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(appRoutes),
        provideAnimations(),
        provideHttpClient(withInterceptors([apiPrefixInterceptor, apiAcceptLanguageInterceptor, apiErrorInterceptor]), withFetch()),
        {
            provide: HttpClient,
            useClass: HttpService,
        },
        // Below Angular's transfer-cache root interceptor: a warm SSR cache hit
        // still bubbles up through it and gets serialized into `ng-state`.
        {
            provide: HttpBackend,
            useClass: SsrCacheBackend,
        },
        provideTranslateService({
            loader: provideTranslateLoader(TranslateLoaderOverrid),
        }),
        provideLanguageInitializer(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.sw,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        provideClientHydration(withIncrementalHydration()),
    ],
};
